var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c(
      "div",
      { staticClass: "products-item-matching-title" },
      [
        _c(
          "feature-flag",
          { attrs: { name: "utility-score" } },
          [
            _vm.matchingPercentage
              ? _c("score", { attrs: { percentage: _vm.matchingPercentage } })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "products-item-matching-title-text-and-arrow",
            on: { click: _vm.onClick },
          },
          [
            _c(
              "span",
              {
                staticClass: "products-item-matching-title-text",
                attrs: { id: _vm.matchingListTitleId },
              },
              [_vm._v(_vm._s(_vm.matchingTitle))]
            ),
            _vm._v(" "),
            _vm.isListExpanded
              ? _c(
                  "svg",
                  {
                    staticClass: "products-item-matching-title-arrow-icon",
                    attrs: {
                      viewBox: "0 0 32 32",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M6 20L16 10L26 20",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                )
              : _c(
                  "svg",
                  {
                    staticClass: "products-item-matching-title-arrow-icon",
                    attrs: {
                      viewBox: "0 0 32 32",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M26 12L16 22L6 12",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }